const HomeIcon = (props) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M10 27V17.625L8.2 19L7 17.4L10 15.1V12H12V13.575L18 9L29 17.4L27.8 18.975L26 17.625V27H10ZM12 25H17V21H19V25H24V16.1L18 11.525L12 16.1V25ZM10 11C10 10.1667 10.2917 9.45833 10.875 8.875C11.4583 8.29167 12.1667 8 13 8C13.2833 8 13.521 7.904 13.713 7.712C13.905 7.52 14.0007 7.28267 14 7H16C16 7.83333 15.7083 8.54167 15.125 9.125C14.5417 9.70833 13.8333 10 13 10C12.7167 10 12.4793 10.096 12.288 10.288C12.0967 10.48 12.0007 10.7173 12 11H10Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default HomeIcon;
